'use strict';

exports.__esModule = true;
exports.getNext = getNext;
exports.allowJobsOnRoute = allowJobsOnRoute;
exports.checkIn = checkIn;
exports.accept = accept;

var _apiClient = require('../../network/api-client');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  COURIER_SHIFTS_NEXT: '/courier/shifts/next',
  COURIER_SHIFTS_CHECK_IN: '/courier/shifts/next/check_in'

  /**
   * Wrapper for `/courier/shifts/next` API endpoint
   */

};var shifts = {
  getNext: getNext,
  allowJobsOnRoute: allowJobsOnRoute,
  accept: accept,
  checkIn: checkIn
};

exports.default = shifts;

/**
 * Get shifts information
 * @returns {promise} containing the shifts
 */

function getNext() {
  return _apiClient2.default.get({ route: API.COURIER_SHIFTS_NEXT });
}

/**
 * Get shifts information
 * @returns {promise}
 */
function allowJobsOnRoute(_ref) {
  var acceptJobs = _ref.acceptJobs;

  var data = { accepted: true, activated: acceptJobs };
  return _apiClient2.default.put({ route: API.COURIER_SHIFTS_NEXT, data: data });
}

/**
 * Check in to shift
 * @returns {promise}
 */
function checkIn() {
  return _apiClient2.default.put({ route: API.COURIER_SHIFTS_CHECK_IN });
}

/**
 * Accept shift - before check in
 * @returns {promise}
 */
function accept() {
  var data = { accepted: true };
  return _apiClient2.default.put({ route: API.COURIER_SHIFTS_NEXT, data: data });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/courier/shifts/shifts.js
// module id = 1183
// module chunks = 0